<p-toast></p-toast>

<div class="app-card">
  <div class="flex flex-col gap-4">
    <div class="flex items-center justify-between">
      <h4 class="text-lg font-semibold text-gray-800 dark:text-white/90">
        Información Personal
      </h4>
      <div class="flex gap-2">
        @if (isEditing) {
          <button
            (click)="toggleEdit()"
            [disabled]="isSaving"
            class="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-700"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
            <span>Cancelar</span>
          </button>
          <button
            (click)="handleSave()"
            [disabled]="isSaving || form.invalid"
            class="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            @if (isSaving) {
              <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Guardando...</span>
            } @else {
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
              <span>Guardar</span>
            }
          </button>
        } @else {
          <button
            (click)="toggleEdit()"
            class="flex items-center gap-2 px-4 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-full shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 transition-colors dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200"
          >
            <svg class="fill-current" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0911 2.78206C14.2125 1.90338 12.7878 1.90338 11.9092 2.78206L4.57524 10.116C4.26682 10.4244 4.0547 10.8158 3.96468 11.2426L3.31231 14.3352C3.25997 14.5833 3.33653 14.841 3.51583 15.0203C3.69512 15.1996 3.95286 15.2761 4.20096 15.2238L7.29355 14.5714C7.72031 14.4814 8.11172 14.2693 8.42013 13.9609L15.7541 6.62695C16.6327 5.74827 16.6327 4.32365 15.7541 3.44497L15.0911 2.78206ZM12.9698 3.84272C13.2627 3.54982 13.7376 3.54982 14.0305 3.84272L14.6934 4.50563C14.9863 4.79852 14.9863 5.2734 14.6934 5.56629L14.044 6.21573L12.3204 4.49215L12.9698 3.84272ZM11.2597 5.55281L5.6359 11.1766C5.53309 11.2794 5.46238 11.4099 5.43238 11.5522L5.01758 13.5185L6.98394 13.1037C7.1262 13.0737 7.25666 13.003 7.35947 12.9002L12.9833 7.27639L11.2597 5.55281Z" fill=""/>
            </svg>
            <span>Editar</span>
          </button>
        }
      </div>
    </div>

    @if (form) {
      <form [formGroup]="form" class="mt-2">
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-x-8">
          <!-- Nombre -->
          <div>
            <label class="block mb-2 text-xs font-medium text-gray-500 dark:text-gray-400">
              Nombre @if (isEditing) { <span class="text-error-500">*</span> }
            </label>
            @if (isEditing) {
              <input
                type="text"
                formControlName="name"
                class="w-full px-4 py-3 text-sm text-gray-700 transition-colors bg-white border rounded-lg dark:bg-gray-800 dark:text-white dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent"
                [ngClass]="{'border-error-500 dark:border-error-500': getFieldError('name')}"
              />
              @if (getFieldError('name')) {
                <p class="mt-1 text-xs text-error-500">{{ getFieldError('name') }}</p>
              }
            } @else {
              <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                {{ usuario.name || '-' }}
              </p>
            }
          </div>

          <!-- Apellido -->
          <div>
            <label class="block mb-2 text-xs font-medium text-gray-500 dark:text-gray-400">
              Apellido @if (isEditing) { <span class="text-error-500">*</span> }
            </label>
            @if (isEditing) {
              <input
                type="text"
                formControlName="lastName"
                class="w-full px-4 py-3 text-sm text-gray-700 transition-colors bg-white border rounded-lg dark:bg-gray-800 dark:text-white dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent"
                [ngClass]="{'border-error-500 dark:border-error-500': getFieldError('lastName')}"
              />
              @if (getFieldError('lastName')) {
                <p class="mt-1 text-xs text-error-500">{{ getFieldError('lastName') }}</p>
              }
            } @else {
              <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                {{ usuario.lastName || '-' }}
              </p>
            }
          </div>

          <!-- Email -->
          <div>
            <label class="block mb-2 text-xs font-medium text-gray-500 dark:text-gray-400">
              Email @if (isEditing) { <span class="text-error-500">*</span> }
            </label>
            @if (isEditing) {
              <input
                type="email"
                formControlName="email"
                class="w-full px-4 py-3 text-sm text-gray-700 transition-colors bg-white border rounded-lg dark:bg-gray-800 dark:text-white dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent"
                [ngClass]="{'border-error-500 dark:border-error-500': getFieldError('email')}"
              />
              @if (getFieldError('email')) {
                <p class="mt-1 text-xs text-error-500">{{ getFieldError('email') }}</p>
              }
            } @else {
              <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                {{ usuario.email || '-' }}
              </p>
            }
          </div>

          <!-- Teléfono -->
          <div>
            <label class="block mb-2 text-xs font-medium text-gray-500 dark:text-gray-400">
              Teléfono
            </label>
            @if (isEditing) {
              <input
                type="text"
                formControlName="phone"
                class="w-full px-4 py-3 text-sm text-gray-700 transition-colors bg-white border rounded-lg dark:bg-gray-800 dark:text-white dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              />
            } @else {
              <p class="text-sm font-medium text-gray-800 dark:text-white/90">
                {{ usuario.phone || '-' }}
              </p>
            }
          </div>
        </div>
      </form>
    }
  </div>
</div>
